import { styled } from '@mui/system';
import { Button } from '@mui/material';

export const BorderedButton = styled<any>(Button)`
    border-radius: 24px;
    //margin-top: 20px;
    //margin-right: 20px;
    box-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.2);
`;
